import React, { useContext } from "react";


import axios from "axios";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Global, { isBusinessAccountType, isStripePaymentConnected } from "../../util/Global";
import { useTranslation } from "react-i18next";
import { LoaderComponent } from "../../util/Loader";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { Autocomplete, Button, CircularProgress, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { GlobalData } from "../../util/GlobalData";
import AvatarUploader from "../../components/AvatarUploader";
import { AlertContext } from "../../util/Alerter";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import FileUploader from "../../components/FileUploader";
import Mapss from "../Mapss";
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import BadgeIcon from '@mui/icons-material/Badge';
import MaleIcon from '@mui/icons-material/Male';
import ContactsIcon from '@mui/icons-material/Contacts';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import NumbersIcon from '@mui/icons-material/Numbers';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import FaxIcon from '@mui/icons-material/Fax';
import BusinessIcon from '@mui/icons-material/Business';
import LanguageIcon from '@mui/icons-material/Language';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import NotFound from "../../components/NotFound";
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import WorkIcon from '@mui/icons-material/Work';
import OpeningHours from "../../components/OpeningHours";
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { CurrencyContext, DeliveryCountryContext } from "../../components/Utils";
import { CurrencySelectorComponent } from "../../components/CurrencySelector";
import VerifiedIcon from '@mui/icons-material/Verified';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

const USER_URL = Global.backend + "/index.php/user/show";
const UPDATE_USER_URL = Global.backend + "/index.php/api/user/edit";
const UPDATE_LOGO_URL = Global.backend + "/index.php/user/uploadlogo";
const UPDATE_PHOTO_URL = Global.backend + "/index.php/user/uploadphoto";
const ONBOARD_STRIPE_URL = Global.backend + "/index.php/api/stripe/onboard-seller";


const EditProfile = ({ isAdmin }) => {
  const { id } = useParams()
  const { t } = useTranslation();
  const [isLoading, setisLoading] = useState(true);
  const [isBusinessAccount, setisBusinessAccount] = useState(false)
  const { countries } = useContext(DeliveryCountryContext)
  const { setfirstName, setlastName, setphoto } = useContext(DashboardHeaderContext)
  const [isUserFound, setisUserFound] = useState(true)
  const [onboardStripe, setonboardStripe] = useState(false)

  // user infos
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [tel, setTel] = useState(0);
  const [facebook, setFacebook] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [tweeter, setTweeter] = useState("");
  const [civilite, setCivilite] = useState("");
  const [adresse, setAdresse] = useState("");
  const [pays, setPays] = useState("");
  const [ville, setVille] = useState("");
  const [codePostale, setCodePostale] = useState("");
  const [fonction, setFonction] = useState("");
  const [service, setService] = useState("");
  const [mobile, setMobile] = useState("");
  const [mail, setMail] = useState("");
  const [photo, setPhoto] = useState("");
  const [isValid, setisValid] = useState(false);

  // business infos
  const [nomentreprise, setNomEntreprise] = useState("");
  const [adresseEntreprise, setadresseEntreprise] = useState("");
  const [paysEntreprise, setpaysEntreprise] = useState("");
  const [villeEntreprise, setvilleEntreprise] = useState("");
  const [codePostaleEntreprise, setcodePostaleEntreprise] = useState("");
  const [telEntreprise, settelEntreprise] = useState("");
  const [mobileEntreprise, setmobileEntreprise] = useState("");
  const [faxEntreprise, setfaxEntreprise] = useState("");
  const [siteEntreprise, setsiteEntreprise] = useState("");
  const [whatsappEntreprise, setwhatsappEntreprise] = useState("");
  const [facebookEntreprise, setfacebookEntreprise] = useState("");
  const [linkedinEntreprise, setlinkedinEntreprise] = useState("");
  const [tweeterEntreprise, settweeterEntreprise] = useState("");
  const [instagrammeEntreprise, setinstagrammeEntreprise] = useState("");
  const [emailEntreprise, setemailEntreprise] = useState("");
  const [activityEntreprise, setactivityEntreprise] = useState("");
  const [aboutEntreprise, setaboutEntreprise] = useState("");
  const [tvaEntreprise, settvaEntreprise] = useState("");
  const [immEntreprise, setimmEntreprise] = useState("");
  const [dateEntreprise, setdateEntreprise] = useState("");
  const [immatriculationEntreprise, setimmatriculationEntreprise] = useState("");
  const [certificatEntreprise, setcertificatEntreprise] = useState("");
  const [logoEntreprise, setlogoEntreprise] = useState("");
  const [regionEntreprise, setregionEntreprise] = useState("");
  const [latEntreprise, setlatEntreprise] = useState();
  const [lonEntreprise, setlonEntreprise] = useState();
  const [legalStructure, setlegalStructure] = useState("")
  const [openingHours, setopeningHours] = useState([])
  const [nbEmployees, setnbEmployees] = useState(0)
  const [annualRevenue, setannualRevenue] = useState(0)
  const { currency } = useContext(CurrencyContext)
  const [entrepriseCurrency, setentrepriseCurrency] = useState(currency)
  const [deliveryFee, setdeliveryFee] = useState(0)
  const [stripeAccountId, setstripeAccountId] = useState()
  const [stripeAccountConnected, setstripeAccountConnected] = useState(false)


  const { showAlert } = useContext(AlertContext)
  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)



  const [errors, setErrors] = useState({
    mail: false,
    nom: false,
    prenom: false,
    telephone: false,
    civilite: false,
    service: false,
    fonction: false,
    mobile: false,
    linkedin: false,
    facebook: false,
    tweeter: false,
    photo: false,
    adresse: false,
    ville: false,
    pays: false,
    code: false,
    nomEntreprise: false,
    adresseEntreprise: false,
    paysEntreprise: false,
    villeEntreprise: false,
    codePostaleEntreprise: false,
    telEntreprise: false,
    mobileEntreprise: false,
    faxEntreprise: false,
    siteEntreprise: false,
    whatsappEntreprise: false,
    facebookEntreprise: false,
    linkedinEntreprise: false,
    tweeterEntreprise: false,
    instagrammeEntreprise: false,
    emailEntreprise: false,
    activityEntreprise: false,
    aboutEntreprise: false,
    tvaEntreprise: false,
    immEntreprise: false,
    dateEntreprise: false,
    immatriculationEntreprise: false,
    certificatEntreprise: false,
    logoEntreprise: false,
    regionEntreprise: false,
    latEntreprise: false,
    lonEntreprise: false,
    legalStructure: false,
    openingHours: false,
    nbEmployees: false,
    annualRevenue: false,
    deliveryFee: false,
    stripeAccountId: false
  });










  useEffect(() => {
    setisLoading(true)

    axios.all([
      axios.post(USER_URL, { userId: isAdmin ? id : localStorage.getItem("id") })
    ]).then(axios.spread((userResponse) => {
      if (!userResponse.data) {
        setisUserFound(false)
        return
      }
      setUser(userResponse);
    })).catch((err) => {
      showAlert("error", t("request.errorFetchingUserData"))
    }).finally(() => {
      setisLoading(false)
    })

  }, []);

  useEffect(() => {
    if (isAdmin) {
      setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
      setnavLinks([{ path: "/dashboard/admin/adminusers", label: "userList" }])
      setalertTitle("")
    } else {
      if (isBusinessAccount && !isValid) {
        setalertTitle(t("accountunderReview"))
      } else {
        setalertTitle("")
      }
      setpageNavLink({ path: "/dashboard", label: "navigation12.1" })
      setnavLinks([])
    }
    setpageTitle("editProfile")
  }, [isBusinessAccount, isValid])


  const handleOnboard = async () => {
    setonboardStripe(true)
    try {
      // Build URL properly to avoid double slashes
      // Remove trailing slash from Global.frontend if it exists, then add path with leading slash
      const basePath = Global.frontend.replace(/\/$/, '');
      const profilePath = '/dashboard/user/modifierprofile';
      const refreshUrl = window.location.origin + basePath + profilePath;
      const returnUrl = window.location.origin + basePath + profilePath;
      
      const response = await axios.post(ONBOARD_STRIPE_URL, {
        refreshUrl: refreshUrl,
        returnUrl: returnUrl
      });

      const accountLinkUrl = response.data.url;

      if (accountLinkUrl) {
        window.location.href = accountLinkUrl;
      } else {
        showAlert("error", t("stripeAccountLinkError") || "Failed to generate Stripe account link");
      }
    } catch (error) {
      let errorMessage = t("stripeAccountConnectionError") || "Failed to connect Stripe account";
      
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        if (errorData.message) {
          errorMessage = errorData.message;
        } else if (errorData.error) {
          errorMessage = errorData.error;
        }
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      showAlert("error", errorMessage);
      console.error("Stripe onboarding error:", error);
    } finally {
      setonboardStripe(false)
    }
  };


  function setUser(response) {
    const isBusinessType = isBusinessAccountType(response.data.compte)
    setisBusinessAccount(isBusinessType)

    if (response.data.id == localStorage.getItem("id")) {
      // save user data to storage
      localStorage.setItem("nom", response.data.nom)
      localStorage.setItem("prenom", response.data.prenom)
      localStorage.setItem("photo", response.data.photo)

      if (isBusinessAccount) {
        localStorage.setItem("logo", response.data.entreprise.logo)
        localStorage.setItem("activite", response.data.entreprise.activite)
      }

      // pass updated data to dashboard header too
      setfirstName(response.data.prenom)
      setlastName(response.data.nom)
      setphoto(response.data.photo ? response.data.photo : (isBusinessType ? response.data.entreprise.logo : ""))
    }



    setNom(response.data.nom);
    setPrenom(response.data.prenom);
    setTel(response.data.telephone);
    setMail(response.data.email);
    setService(response.data.service);
    setFonction(response.data.fonction);
    setCivilite(response.data.civilite);
    setMobile(response.data.mobile);
    setTweeter(response.data.tweeter);
    setLinkedin(response.data.linkedin);
    setFacebook(response.data.facebook);
    setAdresse(response.data.adresse)
    setVille(response.data.ville)
    setPays(response.data.pays)
    setCodePostale(response.data.code)
    setPhoto(`${Global.backend}/uploads/${response.data.photo}`)
    setisValid(response.data.is_valid)


    if (!isBusinessType) {
      return
    }



    setNomEntreprise(response.data.entreprise.nom);
    setadresseEntreprise(response.data.entreprise.adresse);
    setpaysEntreprise(response.data.entreprise.pays);
    setcodePostaleEntreprise(response.data.entreprise.code_postal);
    setregionEntreprise(response.data.entreprise.region);
    settelEntreprise(response.data.entreprise.tel);
    setmobileEntreprise(response.data.entreprise.mobile);
    setwhatsappEntreprise(response.data.entreprise.whatsapp);
    setfaxEntreprise(response.data.entreprise.fax);
    setsiteEntreprise(response.data.entreprise.site);
    setfacebookEntreprise(response.data.entreprise.facebook);
    setlinkedinEntreprise(response.data.entreprise.linkedin);
    settweeterEntreprise(response.data.entreprise.tweeter);
    setinstagrammeEntreprise(response.data.entreprise.instagramme);
    setactivityEntreprise(response.data.entreprise.activite);
    setemailEntreprise(response.data.entreprise.email);
    setvilleEntreprise(response.data.entreprise.ville);
    setaboutEntreprise(response.data.entreprise.about);
    settvaEntreprise(response.data.entreprise.tva);
    setimmEntreprise(response.data.entreprise.imm)
    setdateEntreprise(response.data.entreprise.datecreation);
    setimmatriculationEntreprise(`${Global.backend}/uploads/${response.data.entreprise.immatriculation}`)
    setcertificatEntreprise(`${Global.backend}/uploads/${response.data.entreprise.certificat}`)
    setlogoEntreprise(`${Global.backend}/uploads/${response.data.entreprise.logo}`)
    setlatEntreprise(response.data.entreprise.lat || 0)
    setlonEntreprise(response.data.entreprise.lng || 0)
    setlegalStructure(response.data.entreprise.forme_juridique)
    setnbEmployees(response.data.entreprise.nb_employe)
    setannualRevenue(response.data.entreprise.chiffre_affaire_annuel)
    setentrepriseCurrency(response.data.entreprise.currency)
    setopeningHours(response.data.entreprise.heures_ouverture)
    setdeliveryFee(response.data.entreprise.deliveryFee)
    setstripeAccountId(response.data.entreprise.stripeAccountId)
    setstripeAccountConnected(response.data.entreprise.stripeAccountId)
  }




  const checkInputs = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;



    const errors = {
      mail: !emailRegex.test(mail),
      nom: nom.length < 4,
      prenom: prenom.length < 4,
      telephone: false,
      civilite: false,
      service: isBusinessAccount && !GlobalData.user.services.includes(service),
      fonction: isBusinessAccount && !GlobalData.user.functions.includes(fonction),
      mobile: false,
      linkedin: false,
      facebook: false,
      tweeter: false,
      photo: false,
      adresse: false,
      ville: false,
      pays: false,
      code: false,
      nomEntreprise: isBusinessAccount && nomentreprise.length < 4,
      adresseEntreprise: isBusinessAccount && false,
      paysEntreprise: isBusinessAccount && !paysEntreprise,
      villeEntreprise: isBusinessAccount && !villeEntreprise,
      codePostaleEntreprise: isBusinessAccount && !codePostaleEntreprise,
      telEntreprise: isBusinessAccount && false,
      mobileEntreprise: isBusinessAccount && false,
      faxEntreprise: isBusinessAccount && !faxEntreprise,
      siteEntreprise: isBusinessAccount && false,
      whatsappEntreprise: isBusinessAccount && false,
      facebookEntreprise: isBusinessAccount && false,
      linkedinEntreprise: isBusinessAccount && false,
      tweeterEntreprise: isBusinessAccount && false,
      instagrammeEntreprise: isBusinessAccount && false,
      emailEntreprise: isBusinessAccount && !emailRegex.test(emailEntreprise),
      activityEntreprise: isBusinessAccount && !GlobalData.user.activities.includes(activityEntreprise),
      aboutEntreprise: isBusinessAccount && false,
      tvaEntreprise: isBusinessAccount && !tvaEntreprise,
      immEntreprise: isBusinessAccount && !immEntreprise,
      dateEntreprise: isBusinessAccount && !dateEntreprise,
      immatriculationEntreprise: isBusinessAccount && !immatriculationEntreprise,
      certificatEntreprise: isBusinessAccount && !certificatEntreprise,
      logoEntreprise: isBusinessAccount && false,
      regionEntreprise: isBusinessAccount && false,
      latEntreprise: isBusinessAccount && false,
      lonEntreprise: isBusinessAccount && false,
      deliveryFee: isBusinessAccount && deliveryFee < 0,
      stripeAccountId: isBusinessAccount && false
    };

    setErrors(errors)



    const hasErrors = Object.values(errors).some(error => error)

    if (hasErrors) {
      let errorMessage = ""

      if (errors.mail || errors.telephone || errors.mobile) {
        errorMessage = t("user.verifycontactDetails")
      } else if (errors.nom || errors.prenom || errors.civilite || errors.pays || errors.adresse || errors.ville || errors.code) {
        errorMessage = t("user.verifypersonalInformation")

      } else if (errors.fonction || errors.service) {
        errorMessage = t("user.verifyprofessionalInformation")

      } else if (errors.tweeter || errors.linkedin || errors.facebook) {
        errorMessage = t("user.verifysocialMedia")

      } else if (errors.photo) {
        errorMessage = t("user.verifyavatar")
      }

      else if (isBusinessAccount) {
        if (errors.emailEntreprise || errors.telEntreprise || errors.mobileEntreprise || errors.faxEntreprise) {
          errorMessage = t("user.verifycompanyContactDetails")

        } else if (errors.nomEntreprise || errors.paysEntreprise || errors.adresseEntreprise || errors.ville || errors.codePostaleEntreprise || errors.aboutEntreprise) {
          errorMessage = t("user.verifycompanyGeneralInformation")

        } else if (errors.activityEntreprise || errors.tvaEntreprise || errors.immEntreprise || errors.dateEntreprise) {
          errorMessage = t("user.verifycompanyprofessionalInformation")

        } else if (errors.facebookEntreprise || errors.linkedinEntreprise || errors.tweeterEntreprise || errors.instagrammeEntreprise || errors.whatsappEntreprise || errors.siteEntreprise) {
          errorMessage = t("user.verifycompanysocialMedia")

        } else if (errors.immatriculationEntreprise || errors.certificatEntreprise) {
          errorMessage = t("user.verifylegalInformation")

        } else if (errors.logoEntreprise || errors.latEntreprise || errors.lonEntreprise) {
          errorMessage = t("user.verifylogoAndLocation")
        } else if (errors.deliveryFee) {
          errorMessage = t("verifyPaymentSettings")
        } else if (errors.stripeAccountId) {
          errorMessage = t("verifyStripeAccount")
        }
      }

      showAlert("error", errorMessage)
    }


    return !hasErrors
  }


  function onSubmit() {
    if (!checkInputs()) {
      return
    }


    setisLoading(true);


    const formData = new FormData();


    formData.append("userEditorId", localStorage.getItem("id"));
    formData.append("userId", isAdmin ? id : localStorage.getItem("id"));



    formData.append("nom", nom);
    formData.append("prenom", prenom);
    formData.append("email", mail);
    formData.append("telephone", tel ? tel : 0);
    formData.append("mobile", mobile);
    formData.append("civilite", civilite);
    formData.append("fonction", fonction);
    formData.append("service", service);
    formData.append("linkedin", linkedin);
    formData.append("facebook", facebook);
    formData.append("tweeter", tweeter);
    formData.append("adresse", adresse);
    formData.append("pays", pays);
    formData.append("code_postal", codePostale);
    formData.append("ville", ville);


    if (photo instanceof File) {
      formData.append("photo", photo);
    } else {
      formData.append("photo", "");
    }



    if (isBusinessAccount) {
      formData.append("nomentreprise", nomentreprise);
      formData.append("region", regionEntreprise);
      formData.append("activity", activityEntreprise);
      formData.append("adresseEntreprise", adresseEntreprise);
      formData.append("date", dateEntreprise);
      formData.append("paysEntreprise", paysEntreprise);
      formData.append("code_postalEntreprise", codePostaleEntreprise);
      formData.append("villeEntreprise", villeEntreprise);
      formData.append("whatsapp", whatsappEntreprise);
      formData.append("linkedinEntreprise", linkedinEntreprise);
      formData.append("facebookEntreprise", facebookEntreprise);
      formData.append("tweeterEntreprise", tweeterEntreprise);
      formData.append("instagramme", instagrammeEntreprise);
      formData.append("fax", faxEntreprise);
      formData.append("siteweb", siteEntreprise);
      formData.append("telephoneEntreprise", telEntreprise);
      formData.append("mobileEntreprise", mobileEntreprise);
      formData.append("tva", tvaEntreprise);
      formData.append("imm", immEntreprise);
      formData.append("about", aboutEntreprise);
      formData.append("lat", latEntreprise);
      formData.append("lng", lonEntreprise);
      formData.append("forme_juridique", legalStructure);
      if (openingHours) {
        formData.append("heures_ouverture", openingHours);
      }
      if (nbEmployees) {
        formData.append("nb_employe", nbEmployees);
      }
      if (annualRevenue) {
        formData.append("chiffre_affaire_annuel", annualRevenue);
      }
      formData.append("currency", entrepriseCurrency);
      if (deliveryFee) {
        formData.append("deliveryFee", deliveryFee);
      }
      if (stripeAccountId) {
        formData.append("stripeAccountId", stripeAccountId);
      }





      if (logoEntreprise instanceof File) {
        formData.append("logo", logoEntreprise);
      } else {
        formData.append("logo", "");
      }



      if (immatriculationEntreprise instanceof File) {
        formData.append("immatriculefile", immatriculationEntreprise);
      } else {
        formData.append("immatriculefile", "");
      }

      if (certificatEntreprise instanceof File) {
        formData.append("certificat", certificatEntreprise);
      } else {
        formData.append("certificat", "");
      }
    }







    axios.post(UPDATE_USER_URL, formData).then((response) => {
      try {
        if (response.data.includes("Verify Stripe")) {
          setErrors({ ...errors, stripeAccountId: true })
          showAlert("error", t("verifyStripeAccount"))

          return
        }
      } catch (err) {

      }
      if (stripeAccountId) {
        setstripeAccountConnected(true)
      }


      localStorage.setItem("stripeAccountId", stripeAccountId)


      showAlert("success", t("request.successUpdatingUserData"))
      axios.post(USER_URL, { userId: isAdmin ? id : localStorage.getItem("id") }).then((response) => {
        setUser(response)
      }).catch(() => {

      })
    }).catch((err) => {
      showAlert("error", t("request.errorUpdatingUserData"))
    }).finally(() => {
      setisLoading(false)
    })
  }






  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading &&
        (!isUserFound ? <NotFound /> :
          <div className="container-fluid">


            <div className="card">
              <div className="card-body">
                <div
                  id="addproduct-nav-pills-wizard"
                  className="twitter-bs-wizard"
                >

                  <Tabs>
                    <TabList style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
                      <Tab style={{ width: "100%" }}>{t("signupSteps.accountInfo")}</Tab>
                      {isBusinessAccount && <Tab style={{ width: "100%" }}>{t("signupSteps.businessInfo")}</Tab>}
                      {isBusinessAccount && <Tab style={{ width: "100%" }}>
                        {t("paymentSettings")}
                        {!isAdmin && !isStripePaymentConnected() &&
                          <NewReleasesIcon color="error" />}
                      </Tab>}
                    </TabList>



                    <TabPanel>
                      <div className=" twitter-bs-wizard-tab-content">
                        <div className="tab-pane" id="basic-info">
                          <h4 className="card-title">{t("user.contactDetails")}</h4>
                          <p className="card-title-desc"></p>


                          <div className="row mb-3">
                            <div className="col-4">
                              <TextField value={mail} error={errors.mail} fullWidth variant="outlined" type="text" label={t("user.mail")} onChange={(e) => setMail(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <EmailIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <TextField value={tel} error={errors.telephone} fullWidth variant="outlined" type="text" label={t("user.phone")} onChange={(e) => setTel(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <PhoneIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <TextField value={mobile} error={errors.mobile} fullWidth variant="outlined" type="text" label={t("user.mobile")} onChange={(e) => setMobile(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <PhoneAndroidIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                          </div>
                        </div>




                        <hr />




                        <div className="tab-pane" id="basic-info">
                          <h4 className="card-title">{t("user.personalInformation")}</h4>
                          <p className="card-title-desc"></p>


                          <div className="row mb-3">
                            <div className="col-4">
                              <TextField value={prenom} error={errors.prenom} fullWidth variant="outlined" type="text" label={t("user.firstName")} onChange={(e) => setPrenom(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <BadgeIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <TextField value={nom} error={errors.nom} fullWidth variant="outlined" type="text" label={t("user.lastName")} onChange={(e) => setNom(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <BadgeIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <FormControl error={errors.civilite} fullWidth>
                                <InputLabel>{t("user.civility")}</InputLabel>
                                <Select
                                  IconComponent={MaleIcon}
                                  value={civilite}
                                  label={t("user.civility")}
                                  onChange={(e) => {
                                    setCivilite(e.target.value)
                                  }
                                  }
                                >
                                  {GlobalData.user.civilities.map((val, index) => {
                                    return (
                                      <MenuItem key={index} value={val}>{t("user.civilities." + val)}</MenuItem>
                                    )
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                          </div>






                          <div className="row mb-3">
                            <div className="col-3">
                              <Autocomplete
                                disablePortal
                                fullWidth
                                options={countries.map((val) => ({
                                  label: val.name,
                                  value: val.name
                                }))}
                                value={pays}
                                onChange={(event, newValue) => {
                                  setPays(newValue?.value);
                                }}
                                renderInput={(params) => (
                                  <TextField error={errors.pays} {...params} label={t("user.pays")} variant="outlined" />
                                )}
                                disableClearable={true}
                              />
                            </div>
                            <div className="col-3">
                              <TextField value={adresse} error={errors.adresse} fullWidth variant="outlined" type="text" label={t("user.address")} onChange={(e) => setAdresse(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <ContactsIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-3">
                              <TextField value={ville} error={errors.ville} fullWidth variant="outlined" type="text" label={t("user.city")} onChange={(e) => setVille(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <LocationCityIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-3">
                              <TextField value={codePostale} error={errors.code} fullWidth variant="outlined" type="text" label={t("user.postalCode")} onChange={(e) => setCodePostale(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <NumbersIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                          </div>
                        </div>



                        <hr />


                        {isBusinessAccount &&
                          <div className="tab-pane" id="basic-info">
                            <h4 className="card-title">{t("user.professionalInformation")}</h4>
                            <p className="card-title-desc"></p>


                            <div className="row mb-3">
                              <div className="col-6">
                                <FormControl error={errors.fonction} fullWidth>
                                  <InputLabel>{t("user.function")}</InputLabel>
                                  <Select
                                    IconComponent={WorkOutlineIcon}
                                    value={fonction}
                                    label={t("user.function")}
                                    onChange={(e) => setFonction(e.target.value)}
                                  >
                                    {GlobalData.user.functions.map((val, index) => {
                                      return (
                                        <MenuItem key={index} value={val}>{t("user.functions." + val)}</MenuItem>
                                      )
                                    })}
                                  </Select>
                                </FormControl>
                              </div>
                              <div className="col-6">
                                <FormControl error={errors.service} fullWidth>
                                  <InputLabel>{t("user.service")}</InputLabel>
                                  <Select
                                    IconComponent={SupportAgentIcon}
                                    value={service}
                                    label={t("user.service")}
                                    onChange={(e) => setService(e.target.value)}
                                  >
                                    {GlobalData.user.services.map((val, index) => {
                                      return (
                                        <MenuItem key={index} value={val}>{t("user.services." + val)}</MenuItem>
                                      )
                                    })}
                                  </Select>
                                </FormControl>
                              </div>
                            </div>
                          </div>
                        }




                        <hr />





                        <div className="tab-pane" id="basic-info">
                          <h4 className="card-title">{t("user.socialMedia")}</h4>
                          <p className="card-title-desc"></p>


                          <div className="row mb-3">
                            <div className="col-4">
                              <TextField value={tweeter} error={errors.tweeter} fullWidth variant="outlined" type="text" label={t("user.twitter")} onChange={(e) => setTweeter(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <TwitterIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <TextField value={linkedin} error={errors.linkedin} fullWidth variant="outlined" type="text" label={t("user.linkedin")} onChange={(e) => setLinkedin(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <LinkedInIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <TextField value={facebook} error={errors.facebook} fullWidth variant="outlined" type="text" label={t("user.facebook")} onChange={(e) => setFacebook(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <FacebookIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                          </div>


                        </div>



                        <hr />




                        <div className="tab-pane" id="basic-info">
                          <h4 className="card-title">{t("user.avatar")}</h4>
                          <p className="card-title-desc"></p>




                          <div className="mb-3">
                            <AvatarUploader id={"photo"} image={photo} setImage={setPhoto} />
                          </div>
                        </div>
                      </div>
                    </TabPanel>

                    {isBusinessAccount && <TabPanel>

                      <div className="twitter-bs-wizard-tab-content">
                        <div className="tab-pane" id="basic-info">
                          <h4 className="card-title">{t("user.companyContactDetails")}</h4>
                          <div className="row mb-3">
                            <div className="col-3">
                              <TextField error={errors.emailEntreprise} value={emailEntreprise} fullWidth variant="outlined" type="text" label={t("user.mail")} onChange={(e) => setemailEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <EmailIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-3">
                              <TextField error={errors.telEntreprise} value={telEntreprise} fullWidth variant="outlined" type="text" label={t("user.phone")} onChange={(e) => settelEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <PhoneIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-3">
                              <TextField error={errors.mobileEntreprise} value={mobileEntreprise} fullWidth variant="outlined" type="text" label={t("user.mobile")} onChange={(e) => setmobileEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <PhoneAndroidIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-3">
                              <TextField error={errors.faxEntreprise} value={faxEntreprise} fullWidth variant="outlined" type="text" label={t("user.fax")} onChange={(e) => setfaxEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <FaxIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                          </div>
                        </div>

                        <hr />

                        <div className="tab-pane" id="basic-info">
                          <h4 className="card-title">{t("user.companyGeneralInformation")}</h4>
                          <div className="row mb-3">
                            <div className="col-4">
                              <TextField error={errors.nomEntreprise} value={nomentreprise} fullWidth variant="outlined" type="text" label={t("user.companyName")} onChange={(e) => setNomEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <BusinessIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <Autocomplete
                                disablePortal
                                fullWidth
                                options={countries.map((val) => ({
                                  label: val.name,
                                  value: val.name
                                }))}
                                value={paysEntreprise}
                                onChange={(event, newValue) => {
                                  setpaysEntreprise(newValue?.value);
                                }}
                                renderInput={(params) => (
                                  <TextField error={errors.paysEntreprise} {...params} label={t("user.pays")} variant="outlined" />
                                )}
                                disableClearable={true}
                              />
                            </div>
                            <div className="col-4">
                              <TextField error={errors.regionEntreprise} value={regionEntreprise} fullWidth variant="outlined" type="text" label={t("user.region")} onChange={(e) => setregionEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <LocationCityIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-4">
                              <TextField error={errors.adresseEntreprise} value={adresseEntreprise} fullWidth variant="outlined" type="text" label={t("user.address")} onChange={(e) => setadresseEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <ContactsIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <TextField error={errors.villeEntreprise} value={villeEntreprise} fullWidth variant="outlined" type="text" label={t("user.city")} onChange={(e) => setvilleEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <LocationCityIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <TextField error={errors.codePostaleEntreprise} value={codePostaleEntreprise} fullWidth variant="outlined" type="text" label={t("user.postalCode")} onChange={(e) => setcodePostaleEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <NumbersIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                          </div>



                          <div className="mb-3">
                            <TextField
                              error={errors.aboutEntreprise}
                              fullWidth
                              multiline
                              rows={4}
                              variant="outlined"
                              label={t("user.about")}
                              value={aboutEntreprise}
                              onChange={(e) => setaboutEntreprise(e.target.value)}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <DriveFileRenameOutlineIcon />
                                  </InputAdornment>
                                )
                              }}
                            />
                          </div>


                          <div className="mb-3">
                            <div className="col">
                              <InputLabel>{t("user.openingHours")}</InputLabel>
                              <OpeningHours hours={openingHours} setHours={setopeningHours} />
                            </div>
                          </div>
                        </div>

                        <hr />

                        <div className="tab-pane" id="professional-info">
                          <h4 className="card-title">{t("user.companyprofessionalInformation")}</h4>
                          <div className="row mb-3">
                            <div className="col">
                              <FormControl error={errors.activityEntreprise} fullWidth>
                                <InputLabel>{t("user.activity")}</InputLabel>
                                <Select
                                  IconComponent={WorkIcon}
                                  value={activityEntreprise}
                                  label={t("user.activity")}
                                  onChange={(e) => setactivityEntreprise(e.target.value)}
                                >
                                  {GlobalData.user.activities.map((val, index) => {
                                    return (
                                      <MenuItem key={index} value={val}>{t("user.activities." + val)}</MenuItem>
                                    )
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                            <div className="col">
                              <FormControl error={errors.legalStructure} fullWidth>
                                <InputLabel>{t("user.legalStructure")}</InputLabel>
                                <Select
                                  IconComponent={BusinessIcon}
                                  value={legalStructure}
                                  label={t("user.legalStructure")}
                                  onChange={(e) => {
                                    setlegalStructure(e.target.value)
                                  }
                                  }
                                >
                                  {GlobalData.user.legalStructures.map((val, index) => {
                                    return (
                                      <MenuItem key={index} value={val}>{t("user.legalStructures." + val)}</MenuItem>
                                    )
                                  })}
                                </Select>
                              </FormControl>
                            </div>

                          </div>

                          <div className="row mb-3">
                            <div className="col">
                              <TextField error={errors.tvaEntreprise} value={tvaEntreprise} fullWidth variant="outlined" type="text" label={t("user.tva")} onChange={(e) => settvaEntreprise(e.target.value)} />
                            </div>
                            <div className="col">
                              <TextField error={errors.immEntreprise} value={immEntreprise} fullWidth variant="outlined" type="text" label={t("user.imm")} onChange={(e) => setimmEntreprise(e.target.value)} />
                            </div>
                          </div>


                          <div className="row mb-3">
                            <div className="col">
                              <TextField error={errors.dateEntreprise} value={dateEntreprise} fullWidth variant="outlined" type="number" label={t("user.dateCreation")} onChange={(e) => setdateEntreprise(e.target.value)} InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <EditCalendarIcon />
                                  </InputAdornment>
                                ),
                              }} />
                            </div>
                            <div className="col">
                              <TextField error={errors.annualRevenue} value={annualRevenue} fullWidth variant="outlined" type="number" label={t("user.annualRevenue")} onChange={(e) => setannualRevenue(e.target.value)} InputProps={{
                                endAdornment: (
                                  <h6 style={{ marginTop: "auto", marginBottom: "auto" }}>{entrepriseCurrency}</h6>
                                ),
                              }} />
                            </div>
                            <div className="col">
                              <TextField error={errors.nbEmployees} value={nbEmployees} fullWidth variant="outlined" type="number" label={t("user.nbEmployees")} onChange={(e) => setnbEmployees(e.target.value)} InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <SupervisedUserCircleIcon />
                                  </InputAdornment>
                                ),
                              }} />
                            </div>

                          </div>
                        </div>

                        <hr />



                        <div className="tab-pane" id="files">
                          <h4 className="card-title">{t("user.legalInformation")}</h4>
                          <div className="row mb-3">
                            <div className="col-6">
                              <FileUploader label={t("uploadHoneyTestReport")} attachedFile={immatriculationEntreprise} onChange={setimmatriculationEntreprise} />
                            </div>
                            <div className="col-6">
                              <FileUploader label={t("uploadCompanyRegistrationCertificate")} attachedFile={certificatEntreprise} onChange={setcertificatEntreprise} />
                            </div>
                          </div>
                        </div>

                        <hr />


                        <div className="tab-pane" id="social-media">
                          <h4 className="card-title">{t("user.companysocialMedia")}</h4>
                          <div className="row mb-3">
                            <div className="col-4">
                              <TextField error={errors.facebookEntreprise} value={facebookEntreprise} fullWidth variant="outlined" type="text" label={t("user.facebook")} onChange={(e) => setfacebookEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <FacebookIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <TextField error={errors.linkedinEntreprise} value={linkedinEntreprise} fullWidth variant="outlined" type="text" label={t("user.linkedin")} onChange={(e) => setlinkedinEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <LinkedInIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <TextField error={errors.tweeterEntreprise} value={tweeterEntreprise} fullWidth variant="outlined" type="text" label={t("user.twitter")} onChange={(e) => settweeterEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <TwitterIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-4">
                              <TextField error={errors.instagrammeEntreprise} value={instagrammeEntreprise} fullWidth variant="outlined" type="text" label={t("user.instagram")} onChange={(e) => setinstagrammeEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <InstagramIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <TextField error={errors.whatsappEntreprise} value={whatsappEntreprise} fullWidth variant="outlined" type="text" label={t("user.whatsapp")} onChange={(e) => setwhatsappEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <WhatsAppIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                            <div className="col-4">
                              <TextField error={errors.siteEntreprise} value={siteEntreprise} fullWidth variant="outlined" type="text" label={t("user.site")} onChange={(e) => setsiteEntreprise(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <LanguageIcon />
                                    </InputAdornment>
                                  )
                                }} />
                            </div>
                          </div>
                        </div>

                        <hr />

                        <div className="tab-pane" id="location">
                          <h4 className="card-title">{t("user.logoAndLocation")}</h4>


                          <div className="mb-3">
                            <AvatarUploader id={"logoEntreprise"} image={logoEntreprise} setImage={setlogoEntreprise} />
                          </div>


                          <div className="row mb-3">

                            <div className="col-md-6" style={{ marginLeft: "auto", marginRight: "auto" }}>
                              <Mapss lat={latEntreprise} lon={lonEntreprise} canEdit={true} setPosition={(e) => {
                                setlatEntreprise(e[0])
                                setlonEntreprise(e[1])
                              }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>


                    }
                    {isBusinessAccount &&
                      <TabPanel>
                        <div className="twitter-bs-wizard-tab-content">
                          <div className="tab-pane" id="basic-info">
                            <h4 variant="h4" className="card-title mb-4">
                              {t("paymentSettings")}
                            </h4>

                            <Grid container spacing={3}>

                              <Grid item xs={12} sm={6} md={4}>

                                <Typography variant="body1" gutterBottom>
                                  {t("stripeAccountConnected")}: {stripeAccountConnected && !errors.stripeAccountId ? <VerifiedIcon color="success" /> : <NewReleasesIcon color="error" />}
                                </Typography>

                                <TextField error={errors.stripeAccountId} value={stripeAccountId} fullWidth variant="outlined" type="text" label={t("stripeAccountId")} onChange={(e) => setstripeAccountId(e.target.value)} InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <EditCalendarIcon />
                                    </InputAdornment>
                                  ),
                                }} />

                                <Typography variant="body1" gutterBottom>
                                  {t("or")}
                                </Typography>

                                <Button
                                  variant="contained"
                                  color="primary"
                                  fullWidth
                                  onClick={handleOnboard}
                                  disabled={onboardStripe}
                                >
                                  {onboardStripe ? (
                                    <CircularProgress size={30} />
                                  ) : (
                                    t("onboardWithStripe")
                                  )}

                                </Button>

                              </Grid>


                              <Grid item xs={12} sm={6} md={4}>
                                <Typography variant="body1" gutterBottom>
                                  {t("defaultCurrency")}
                                </Typography>
                                <CurrencySelectorComponent
                                  fullWidth={true}
                                  blackStyle={true}
                                  currency={entrepriseCurrency}
                                  handleCurrencyChange={(e) => setentrepriseCurrency(e.target.value)}
                                />
                              </Grid>


                              <Grid item xs={12} sm={6} md={4}>
                                <Typography variant="body1" gutterBottom>
                                  {t("deliveryFeeLabel")}
                                </Typography>
                                <TextField error={errors.deliveryFee} value={deliveryFee} fullWidth variant="outlined" type="number" label={t("deliveryFee")} onChange={(e) => setdeliveryFee(e.target.value)} InputProps={{
                                  endAdornment: (
                                    <h6 style={{ marginTop: "auto", marginBottom: "auto" }}>{entrepriseCurrency}</h6>
                                  ),
                                }} />
                              </Grid>




                            </Grid>
                          </div>
                        </div>
                      </TabPanel>
                    }
                  </Tabs>





                  <div
                    className="tab-pane"
                    id="metadata"
                    style={{ cursor: "pointer" }}
                  >
                    <ul className="pager wizard twitter-bs-wizard-pager-link">
                      <li
                        className="float-end"
                        style={{ cursor: "pointer" }}
                      >

                        <a onClick={() => { onSubmit() }}>
                          {t("save")}
                          <i className="mdi mdi-arrow-right ml-1"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </LoaderComponent>
  );
};

export default EditProfile;
